import {SelectionMode} from "./WorkersCalendarHeader";
import React, {FC} from "react";
import {useWorkerCalendarDays} from "../orders/redux/orders.hook";
import {Divider, Typography} from "@material-ui/core";
import {setDate} from "date-fns";
import {WorkersCalendarDay} from "./WorkersCalendarDay";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    workerMonthTimeline: {
        display: 'flex',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        alignItems: "center"
    },
    nameContainer: {
        width: 180
    },
    timelineContainer: {
        display: 'flex',
        justifyContent: "space-between",
        flex: 1
    }
}))

interface WorkersCalendarLaneProps {
    worker: { id: string; name: string };
    selectedMonth: Date;
    amountOfDays: number;
    selectionMode: SelectionMode;
}

export const WorkersCalendarLane: FC<WorkersCalendarLaneProps> = ({
                                                                      worker,
                                                                      selectedMonth,
                                                                      selectionMode
                                                                  }) => {

    const classes = useStyles();

    const {
        workerDays,
        workerAvailabilities
    } = useWorkerCalendarDays(worker.id, selectedMonth);

    const timelineElement = (
        <React.Fragment>
            <div className={classes.workerMonthTimeline}>
                <Typography className={classes.nameContainer}>
                    {worker.name}
                </Typography>
                <div className={classes.timelineContainer}>
                    {workerDays.map((workerDay, dayIndex) => (
                        <WorkersCalendarDay
                            key={"day-" + dayIndex}
                            worker={worker}
                            dayDate={setDate(selectedMonth, dayIndex + 1)}
                            isFirstDayOfMonth={dayIndex === 0}
                            workerDay={workerDay}
                        />
                    ))}
                </div>
            </div>
            <Divider/>
        </React.Fragment>
    )

    if (
        (selectionMode === 'busy' && (workerAvailabilities.length > 0))
        || (selectionMode === 'idle' && (workerAvailabilities.length === 0))
        || (selectionMode === 'busy-idle')
    ) {
        return timelineElement;
    }
    return <></>;
}
